import {
  Box,
  Button,
  Radio,
  Group,
  Modal,
  Select,
  TextInput,
  Textarea,
  createStyles,
  rem,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect } from "react";

import swal from "sweetalert";

import { DateInput, DatePickerInput } from "@mantine/dates";

import moment from "moment";
import { useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { IconChevronDown } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { AddMedication, EditMedication } from "../../services/patient";
import { decrypt, defaultImage, showError } from "../../utils";
import useStyles from "./style";
import CloseCircle from "../CloseCircle";
import NarcoticBox from "../NarcoticBox";
import { Dropzone } from "@mantine/dropzone";
import ScheduleMenu from "./ScheduleMenu";
import { useDisclosure } from "@mantine/hooks";
import ConfirmationModal from "../ConfirmationModal";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";

const bgColor = "rgba(242, 242, 242, 0.6)";

const AddNewMedicationModal = ({
  opened,
  onclose,
  userId,
  selectedClient,
  data,
  isPreview,
  currentPage,
  getAllPatients,
  setShowClientForm,
  getClientData,
  closeAskMedicalModal,
}) => {
  const { classes, cx } = useStyles();
  const client = useSelector((state) => state.mar.selectedClient);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("scheduled");
  const [files, setFiles] = useState([]);
    const { profile } = useSelector((state) => state.profile);
    const businessTimezone = profile?.business?.timezone || "UTC";
  const [frequencyData, setFrequencyData] = useState([
    "QAM",
    "QPM",
    "Q4HR",
    "Q2HR",
    "Q6HR",
    "Q8HR",
    "Q12HR",
    "AC",
    "PC",
    "BID",
    "TID",
    "QID",
    "STAT",
    "QOD",
    "Noon",
    "QD",
    "5x/day",
    "6x/day",
    "AC",
    "AC HS",
    "AC breakfast",
    "AC breakfast/dinner",
    "AC breakfast/lunch",
    "AC dinner",
    "AC lunch",
    "AC lunch/dinner",
    "BID",
    "BID AC",
    "BID HS",
    "BID PC",
    "BID w/meals",
    "Daily",
    "Daily AC",
    "Every other day",
    "Every other evening",
    "On call",
    "Once",
    "PC",
    "PC HS",
    "q2h",
    "q2min",
    "q30min",
    "q36hr",
    "q3day",
    "q3h",
    "q3min",
    "q48h",
    "q4h",
    "q5min",
    "q6h",
    "q6min",
    "q72h",
    "q4day",
    "q5day",
    "q7day",
    "q10day",
    "q14day",
    "q21day",
    "q28day",
    "q7min",
    "q8h",
    "q8min",
    "q96hrs",
    "q2week",
    "PC breakfast",
    "PC breakfast/dinner",
    "PC breakfast/lunch",
    "PC dinner",
    "PC lunch",
    "PC lunch/dinner",
    "QID",
    "TID",
    "TID AC",
    "TID HS",
    "TID PC",
    "TID w/meals",
    "Today",
    "UD",
    "Before discharge",
    "p each loose BM",
    "q10min",
    "q12h",
    "q15min",
    "q1h",
    "q1min",
    "q20min",
    "q24h",
    "q3week",
    "q4week",
    "q6week",
    "q2month",
    "q3month",
    "q4month",
    "q6month",
    "qAM",
    "qPM",
    "qAM HS",
    "qAM PM",
    "qHS",
    "qmonth",
    "qweek",
    "qyear",
    "qShift",
    "w/breakfast",
    "w/breakfast/dinner",
    "w/breakfast/lunch",
    "w/dinner",
    "w/lunch",
    "w/lunch/dinner",
    "w/meals",
    "w/meals HS",
    "x1",
    "Daily",
    "Once Weekly",
    "Once Monthly",
  ]);
  const [selectedDays, setSelectedDays] = useState(
    data?.repeatOn || [moment().format("dddd")]
  );
  const [isMedicationCountEnabled, setIsMedicationCountEnabled] =
    useState("yes");

  const [confirmModal, { open: confirmOpen, close: confirmClose }] =
    useDisclosure(false);

  const handleRadioChange = (event) => {
    const checked = event;
    setIsMedicationCountEnabled(checked);
    if (checked?.toLowerCase() === "no") {
      form.setFieldValue("totalMedicine", "unlimited");
      form.setFieldValue("medicineRemaining", "unlimited");
    } else if (checked?.toLowerCase() === "yes") {
      // if checkbox is unchecked
      if (data) {
        // if editing
        if (
          data?.totalMedicine == "unlimited" &&
          data?.medicineRemaining == "unlimited"
        ) {
          // if previously totalMedicine and medicineRemaining were unlimited
          form.setFieldValue("totalMedicine", null);
          form.setFieldValue("medicineRemaining", null);
        } else {
          form.setFieldValue("totalMedicine", data?.totalMedicine);
          form.setFieldValue("medicineRemaining", data?.medicineRemaining);
        }
      } else {
        form.setFieldValue("totalMedicine", null);
        form.setFieldValue("medicineRemaining", null);
      }
    }
  };

  const validation = () => {
    const _validation = {
      isPrescribed: (value) => (value ? null : "Required"),
      isNarcotic: (value) => (value ? null : "Required"),
      medicationName: (value) => (value ? null : "Required"),
      medicationType: (value) => (value ? null : "Required"),
      // dosage: (value) => (value ? null : "Required"),
      // unit: (value) => (value ? null : "Required"),
      // frequency: (value) => (value ? null : "Required"),
      ingestionMode: (value) => (value ? null : "Required"),
      totalMedicine: (value) => (value ? null : "Required"),
      medicationadministered: (value) => (value ? null : "Required"),
      medicationInstruction: (value) => (value ? null : "Required"),
      medicationDate: (value) => (value ? null : "Required"),
      medicineRemaining: (value) => (value ? null : "Required"),
      timeSlots: (value) => (value ? null : "Required"),
    };
    if (data) {
      delete _validation?.medicineRemaining;
    } else if (type === "PRN") {
      delete _validation?.timeSlots;
    }
    return _validation;
  };
  // const _initialValues = {
  //   isPrescribed: "Yes",
  //   isNarcotic: "Yes",
  //   medicationName: "Aleoya",
  //   medicationType: "scheduled",
  //   dosage: 200,
  //   unit: "mg",
  //   frequency: "Q4HR",
  //   ingestionMode: "Buccal",
  //   dosageForm: "Tablet",
  //   totalMedicine: 200,
  //   medicationUse: "qwertyu",
  //   medicationInstruction: "qwerty",
  //   responsibleParty: "Family",
  //   administering: "Family",
  //   medicationDate: new Date("2024/07/28"),
  //   expirationDate: new Date("2024/09/30"),
  //   timeSlots: ["02:00 AM", "08:00 PM"],
  //   medicineRemaining: 180,
  //   medicationadministered: 3,
  //   orderDate: null,
  //   repeatEvery: 1,
  //   repeatType: "week",
  //   repeatOn: [
  //     moment("2024/07/29").format("dddd"),
  //     moment("2024/07/30").format("dddd"),
  //     moment("2024/07/31").format("dddd"),
  //   ],
  //   scheduleType: "custom",
  // };
  const _initialValues = {
    isPrescribed: "",
    isNarcotic: "",
    medicationName: "",
    medicationType: "",
    dosage: "",
    unit: "",
    frequency: "",
    ingestionMode: "",
    dosageForm: "",
    totalMedicine: "",
    medicationUse: "",
    medicationInstruction: "",
    responsibleParty: "",
    administering: "",
    medicationDate: new Date(),
    expirationDate: null,
    timeSlots: [],
    medicineRemaining: "",
    medicationadministered: "",
    orderDate: null,
    repeatEvery: 1,
    repeatType: "day",
    repeatOn: [moment().format("dddd")],
    scheduleType: "daily",
  };
  const form = useForm({
    initialValues: _initialValues,
    validate: validation(),
  });

  useEffect(() => {
    if (data) {
      form.setValues({
        ...data,
        medicineRemaining: data?.medicineRemaining,
        ingestionMode: data?.ingestionMethod || data?.ingestionMode,
        medicationDate: data?.medicationDate
          ? new Date(data?.medicationDate)
          : null,
        expirationDate:
          data && isPreview && (data?.hasExpiryDate == "false" || data?.hasExpiryDate == false)
            ? ""
            : data && (data?.hasExpiryDate == "false" || data?.hasExpiryDate == false)
            ? ""
            : data?.medicationEndDate && data?.medicationEndDate != "null"
            ? new Date(data?.medicationEndDate)
            : null,
        medicationEndDate:
          data && isPreview && data?.hasExpiryDate == "false"
            ? ""
            : data && data.hasExpiryDate == "false"
            ? ""
            : data?.medicationEndDate && data?.medicationEndDate != "null"
            ? new Date(data?.medicationEndDate)
            : null,
        repeatEvery: Number(data?.repeatEvery || 1),
        orderDate:
          data?.orderDate &&
          data?.orderDate != "null" &&
          data?.orderDate != "undefined"
            ? new Date(data?.orderDate)
            : null,
      });

      if (
        data?.medicineRemaining == "unlimited" &&
        data?.totalMedicine == "unlimited"
      ) {
        setIsMedicationCountEnabled("no");
      } else {
        setIsMedicationCountEnabled("yes");
      }
    }
  }, [data]);

  const reset = () => {
    getClientData?.();
    setLoading(false);
    form.reset();
    setIsMedicationCountEnabled("yes");
    onclose();
    setFiles([]);
  };

  const handleDateConverter = (date, timeslot = null) => {
    const currentDate = new Date(date);
    const timeString = timeslot;

    if (timeslot) {
      const [time, modifier] = timeString.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) {
        hours += 12;
      }
      if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      let newdate = currentDate.setHours(hours, minutes, 0, 0);
      return moment(newdate);
    } else {
      return moment(date);
    }
  };

  const setScheduleDates = (values) => {
    const _format = "YYYY-MM-DD";
    // let _startDate = moment.tz(moment(values?.medicationDate), moment.tz.guess()).tz("UTC");
    let _startDate = moment(values?.medicationDate).startOf("day");

    let _endDate = values?.expirationDate
      ? moment(values?.expirationDate)
      : moment().endOf("year");

    let _dateRange = [];
    let _currentDate = _startDate.clone();
    let _finalDateWithTimeSlots = [];

    if (values?.scheduleType === "custom") {
      if (values?.repeatType === "day") {
        // For Day
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          _dateRange.push(_currentDate.format(_format));
          _currentDate.add(values?.repeatEvery, "day");
        }

        _dateRange?.forEach((date) => {
          values?.timeSlots.forEach((time) => {
            _finalDateWithTimeSlots.push({
              date: moment(date).toISOString(),
              timeslot: time,
            });
            // _finalDateWithTimeSlots.push(
            //     moment.tz(moment(date + " " + time), user?.timeZone)?.toISOString()
            //     // moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
          });
        });
      } else if (values?.repeatType === "week") {
        // For Week
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          let days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          let days_dates = Array.from({ length: 7 }, (_, i) =>
            _currentDate
              .clone()
              .startOf("week")
              .add(i, "days")
              .format("MM-DD-YYYY")
          );

          values?.repeatOn?.map((day) => {
            let index = days?.indexOf(day);
            if (
              index !== -1 &&
              moment(days_dates[index]).isSameOrAfter(_startDate) &&
              moment(days_dates[index]).isSameOrBefore(_endDate)
            ) {
              // _currentDate.format(_format)
              // _dateRange.push(moment(days_dates[index]).toISOString());
              _dateRange.push(moment(days_dates[index]).format(_format));
              // _dateRange.push(moment(days_dates[index]).tz(user?.timeZone).format(_format));
            }
          });
          _currentDate.add(values?.repeatEvery, "week");
        }

        _dateRange?.forEach((date) => {
          values?.timeSlots?.forEach((time) => {
            // _finalDateWithTimeSlots.push(
            //     moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
            // if (serverFeTimeDiff > 20000) {
            //     console.log("🚀 ~ values?.timeSlots?.split ~ diff if:", diff)
            // } else {
            //     console.log("🚀 ~ values?.timeSlots?.split ~ diff else:", diff)

            // _finalDateWithTimeSlots.push(
            //     moment(date + " " + "00:00 AM" , "YYYY-MM-DD hh:mm A").tz("UTC").subtract(Math.abs(diff) , "hours").add(2 , "hours")?.toISOString()
            //   );

            // theory how it will work
            //  we need to cater three timeZones
            //  BE = KHI, FE = Brazil, UTC TimeZone
            //  first of all calculate the difference between BE and FE timezone here = 8 hours
            //  after
            //

            // let currentDate = moment(date, "YYYY-MM-DD").tz(user?.timeZone) // first convert this value to FE Timezone then you have to add/subtract 8 hours BE FE Timezone difference
            // let timeslot;

            // if (serverFeTimeDiff >= 0) {
            //     timeslot = currentDate.add(serverFeTimeDiff , 'hours').format("hh:mm A")
            //     currentDate = currentDate.add(serverFeTimeDiff , 'hours').tz("UTC")
            // } else {
            //     timeslot = currentDate.subtract(Math.abs(serverFeTimeDiff) , 'hours').format("hh:mm A")
            //     currentDate = currentDate.subtract(Math.abs(serverFeTimeDiff) , 'hours').tz("UTC")
            // }
            // then get start of day
            // then add the fixed hours like 02:00 AM == 2 hours
            // then convert it to UTC and save in server

            // currentDate = currentDate.startOf('day')

            // console.log('frontend time start day', currentDate)
            // currentDate = currentDate.add(2, "hours")
            // console.log(' added', currentDate)
            // console.log(' added', moment(currentDate).tz(user.timeZone))

            // currentDate = currentDate.tz("UTC")
            // console.log('timeslot ',timeslot)

            // let final = moment
            //   .tz(handleDateConverter(date, time), moment.tz.guess())
            //   .tz("UTC")
            //   .toISOString();
            let final = moment(date).toISOString();

            _finalDateWithTimeSlots.push({
              // date :  handleDateConverter(date,time)?.toISOString(),
              date: final,
              timeslot: time,
            });

            // }
          });
        });
      } else {
        // For Month
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          _dateRange.push(_currentDate.format(_format));
          _currentDate.add(values?.repeatEvery, "month");
        }

        _dateRange?.forEach((date) => {
          // values?.timeSlots?.split(",").forEach((time) => {
          values?.timeSlots?.forEach((time) => {
            _finalDateWithTimeSlots.push({
              date: moment(date).toISOString(),
              timeslot: time,
            });
            // _finalDateWithTimeSlots.push(
            //     moment.tz(moment(date + " " + time), user?.timeZone)?.toISOString()
            //     // moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
          });
        });
      }
    } else if (values?.scheduleType === "daily") {
      while (_currentDate.isSameOrBefore(_endDate, "day")) {
        _dateRange.push(_currentDate.format(_format));
        _currentDate.add(values?.repeatEvery, "day");
      }

      _dateRange?.forEach((date) => {
        values?.timeSlots.forEach((time) => {
          _finalDateWithTimeSlots.push({
            date: moment(date).toISOString(),
            timeslot: time,
          });
        });
      });
    }
    return {
      scheduleDates: _finalDateWithTimeSlots,
      startDate: _startDate,
      endDate: _endDate,
    };
  };

  const onSave = async (values) => {
    if (
      (Number(values?.medicineRemaining) || 0) > Number(values?.totalMedicine)
    ) {
      return swal(
        "Error",
        "Current Medication Count cannot exceed Medication Total Quantity.",
        "error"
      );
    }

    if (
      Number(values?.medicationadministered) >
        Number(values?.medicineRemaining) &&
      !data
    ) {
      return swal(
        "Error",
        "Dosage Administered count cannot exceed Current Medication Count.",
        "error"
      );
    }

    let clientId = selectedClient ? selectedClient?.id : client?.id;

    if (data) {
      const checkArrays = (arr1, arr2) => {
        if (
          !Array.isArray(arr1) ||
          !Array.isArray(arr2) ||
          arr1.length !== arr2.length
        ) {
          return true;
        }

        for (let i = 0; i < arr1.length; i++) {
          if (arr2.indexOf(arr1[i]) == -1) {
            return true;
          }
          // if (arr1[i] !== arr2[i]) {
          //   return true;
          // }
        }

        return false;
      };
      const _format = "YYYY-MM-DD";
      const _medicationType = data?.medicationType !== values?.medicationType;
      const _startDate =
        moment(data?.medicationDate).format(_format) !==
        moment(values?.medicationDate).format(_format);
      const _endDate =
        data?.expirationDate &&
        data?.expirationDate != "null" &&
        moment(data?.expirationDate).format(_format) !==
          moment(values?.expirationDate).format(_format);
      const _timeSlots = checkArrays(data?.timeSlots, values?.timeSlots);
      const _repeatOn =
        data?.scheduleType === "custom"
          ? checkArrays(data?.repeatOn, values?.repeatOn)
          : false;

      const _scheduleType =
        data?.scheduleType && values?.scheduleType
          ? data?.scheduleType !== values?.scheduleType
          : false;
      const _repeatEvery =
        data?.scheduleType === "custom"
          ? Number(data?.repeatEvery) &&
            Number(data?.repeatEvery) != Number(values?.repeatEvery)
          : false;
      const _repeatType =
        data?.scheduleType === "custom"
          ? data?.repeatType && data?.repeatType !== values?.repeatType
          : false;

      if (
        _medicationType ||
        _startDate ||
        _endDate ||
        _timeSlots ||
        _scheduleType ||
        _repeatEvery ||
        _repeatType ||
        _repeatOn
      ) {
        confirmOpen();
      } else {
        handleEdit(false);
      }
    } else {
      if (!values?.timeSlots?.length && values?.medicationType != "PRN")
        return showError("Select time slots for medicine.");

      const { scheduleDates } = setScheduleDates(values);

      const _formData = new FormData();
      files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
      _formData.append("administering", values?.administering);
      _formData.append("dosage", values?.dosage);
      _formData.append("dosageForm", values?.dosageForm);
      _formData.append(
        "expirationDate",
        // values?.expirationDate ? values?.expirationDate?.toISOString() : null
        values?.expirationDate
          ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
          : null
        // values?.expirationDate ? moment(values?.expirationDate)?.endOf("D") : null
      );
      _formData.append("frequency", values?.frequency);
      _formData.append("ingestionMode", values?.ingestionMode);
      _formData.append("isNarcotic", values?.isNarcotic);
      _formData.append("isPrescribed", values?.isPrescribed);
      _formData.append(
        "medicationDate",
        values?.medicationDate ? values?.medicationDate?.toISOString() : null
        // values?.medicationDate ? moment(values?.medicationDate)?.startOf("D")?.toISOString() : null
        // values?.medicationDate ? moment(values?.medicationDate)?.startOf("D") : null
      );

      // Start of Day on Frontend Date with 00:00:00 1 Aug 2024 Karachi Time.

      _formData.append("medicationInstruction", values?.medicationInstruction);
      _formData.append("medicationName", values?.medicationName);
      _formData.append("medicationType", values?.medicationType);
      _formData.append("medicationUse", values?.medicationUse);
      _formData.append(
        "medicationadministered",
        values?.medicationadministered
      );
      _formData.append(
        "medicineRemaining",
        // Number(values?.medicineRemaining) || 0
        values?.medicineRemaining
      );
      _formData.append("orderDate", values?.orderDate?.toISOString());
      _formData.append("responsibleParty", values?.responsibleParty);
      _formData.append("timeSlots", values?.timeSlots);
      _formData.append("totalMedicine", values?.totalMedicine);
      _formData.append("unit", values?.unit);
      _formData.append(
        "medicineProvided",
        Number(values?.medicineRemaining) || 0
      );
      _formData.append("id", Date.now());
      if (values?.scheduleType === "custom") {
        _formData.append("scheduleType", values?.scheduleType);
        _formData.append("repeatEvery", values?.repeatEvery);
        _formData.append("repeatType", values?.repeatType);
        _formData.append("repeatOn", values?.repeatOn);
      } else {
        _formData.append("scheduleType", "daily");
      }
      _formData.append(
        "medicationEndDate",
        values?.expirationDate
          ? // ? moment(values?.expirationDate)?.toISOString()
            moment(values?.expirationDate)?.endOf("D")?.toISOString()
          : // ? moment(values?.expirationDate)?.endOf("D")
            moment().endOf("year").toISOString()
      );

      _formData.append("scheduleDates", JSON.stringify(scheduleDates));

      _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
      // _formData.append("timezone", businessTimezone ? businessTimezone : moment.tz.guess());

      setLoading(true);
      await AddMedication(_formData, clientId, false, null, reset);
      if (selectedClient) {
        closeAskMedicalModal();
        setShowClientForm(false);
      }
      setLoading(false);
    }
  };

  const handleEdit = async (confirm) => {
    if (confirmModal) {
      confirmClose();
    }
    const values = form.values;

    let current = moment().startOf("day");
    // const { scheduleDates } = setScheduleDates({
    //   ...values,
    //   medicationDate: current,
    // });

    // const { scheduleDates } = setScheduleDates(values)

    const _formData = new FormData();
    files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
    _formData.append("administering", values?.administering);
    _formData.append("dosage", values?.dosage);
    _formData.append("dosageForm", values?.dosageForm);
    _formData.append(
      "expirationDate",
      values?.expirationDate ? values?.expirationDate?.toISOString() : null
    );
    _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
    _formData.append("frequency", values?.frequency);
    _formData.append("ingestionMode", values?.ingestionMode);
    _formData.append("isNarcotic", values?.isNarcotic);
    _formData.append("isPrescribed", values?.isPrescribed);
    _formData.append(
      "medicationDate",
      values?.medicationDate ? values?.medicationDate?.toISOString() : null
    );
    _formData.append("medicationInstruction", values?.medicationInstruction);
    _formData.append("medicationName", values?.medicationName);
    _formData.append("medicationType", values?.medicationType);
    _formData.append("medicationUse", values?.medicationUse);
    _formData.append("medicationadministered", values?.medicationadministered);
    // _formData.append("medicineRemaining", Number(data?.medicineRemaining) || 0);
    // _formData.append("medicineRemaining", data?.medicineRemaining);
    _formData.append("orderDate", values?.orderDate?.toISOString());
    _formData.append("responsibleParty", values?.responsibleParty);
    _formData.append("timeSlots", values?.timeSlots);
    _formData.append("totalMedicine", values?.totalMedicine);
    _formData.append("unit", values?.unit);
    _formData.append("medicineProvided", Number(data?.medicineRemaining) || 0);
    _formData.append("id", data?.id);
    if (values?.scheduleType === "custom") {
      _formData.append("scheduleType", values?.scheduleType);
      _formData.append("repeatEvery", values?.repeatEvery);
      _formData.append("repeatType", values?.repeatType);
      _formData.append("repeatOn", values?.repeatOn);
    } else {
      _formData.append("scheduleType", "daily");
    }
    _formData.append("confirm", confirm);
    _formData.append(
      "medicationEndDate",
      values?.expirationDate
        ? moment(values?.expirationDate)?.toISOString()
        : moment().endOf("year").toISOString()
    );
    _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
    // _formData.append("scheduleDates", JSON.stringify(scheduleDates));

    if (
      data?.totalMedicine == "unlimited" &&
      data?.medicineRemaining == "unlimited" &&
      isMedicationCountEnabled?.toLowerCase() === "yes"
    ) {
      // _formData.append("medicineRemaining", "unlimited");
      _formData.append("medicineRemaining", values?.medicineRemaining);
    } else if (isMedicationCountEnabled?.toLowerCase() === "no") {
      _formData.append("medicineRemaining", "unlimited");
    } else {
      _formData.append("medicineRemaining", data?.medicineRemaining);
    }

    let newStartDate = moment(values?.medicationDate).format("MM-DD-YYYY");
    let oldStartDate = moment(data?.medicationDate).format("MM-DD-YYYY");
    // let oldScheduleType = data?.scheduleType;
    // _formData.append("old_schedule_type", oldScheduleType);
    // _formData.append("old_timeSlots", data?.timeSlots);

    let newEndDate = values?.expirationDate
      ? moment(values?.expirationDate)?.toISOString()
      : moment().endOf("year").toISOString();
    // let newEndDate = moment(values?.expirationDate).format("MM-DD-YYYY");
    let oldEndDate = moment(data?.medicationEndDate).format("MM-DD-YYYY");

    if (moment(newStartDate) < moment(oldStartDate)) {
      // if(values?.scheduleType === "custom" && values?.repeatType === "week"){
      //   const { scheduleDates } = setScheduleDates({
      //     medicationDate: values?.medicationDate,
      //     expirationDate: moment(data?.expirationDate),
      //     // expirationDate: moment(data?.medicationDate).subtract(1, "days"),
      //     scheduleType: values?.scheduleType,
      //     repeatType: values?.repeatType,
      //     repeatEvery: values?.repeatEvery,
      //     repeatOn: values?.repeatOn,
      //     timeSlots: values?.timeSlots,
      //   })

      //   let filteredSchedules = scheduleDates?.filter(_s => moment(_s?.date).isBefore(data?.medicationDate))

      //   _formData.append("new_start_schedules", JSON.stringify(filteredSchedules));
      //   _formData.append("old_start_date", moment(oldStartDate));
      //   _formData.append("new_start_date", moment(newStartDate));
      // } else {
      //   const { scheduleDates } = setScheduleDates({
      //     medicationDate: values?.medicationDate,
      //     expirationDate: moment(data?.medicationDate).subtract(1, "days"),
      //     scheduleType: values?.scheduleType,
      //     repeatType: values?.repeatType,
      //     repeatEvery: values?.repeatEvery,
      //     repeatOn: values?.repeatOn,
      //     timeSlots: values?.timeSlots,
      //   })

      //   _formData.append("new_start_schedules", JSON.stringify(scheduleDates));
      //   _formData.append("old_start_date", moment(oldStartDate));
      //   _formData.append("new_start_date", moment(newStartDate));
      // }

      const { scheduleDates } = setScheduleDates({
        medicationDate: values?.medicationDate,
        expirationDate: moment(data?.medicationDate).subtract(1, "days"),
        scheduleType: values?.scheduleType,
        repeatType: values?.repeatType,
        repeatEvery: values?.repeatEvery,
        repeatOn: values?.repeatOn,
        timeSlots: values?.timeSlots,
      });

      _formData.append("new_start_schedules", JSON.stringify(scheduleDates));
      _formData.append("old_start_date", moment(oldStartDate));
      _formData.append("new_start_date", moment(newStartDate));
    } else if (moment(newStartDate) > moment(oldStartDate)) {
      _formData.append("old_start_date", moment(oldStartDate));
      _formData.append("new_start_date", moment(newStartDate));
    }

    if (moment(newEndDate) < moment(oldEndDate)) {
      _formData.append("old_end_date", moment(oldEndDate));
      _formData.append("new_end_date", moment(newEndDate));
    } else if (moment(newEndDate) > moment(oldEndDate)) {
      // if(values?.scheduleType === "custom" && values?.repeatType === "day"){
      if (values?.scheduleType === "custom") {
        const { scheduleDates } = setScheduleDates({
          // medicationDate: moment(data?.expirationDate).add(1, "days"),
          medicationDate: values?.medicationDate,
          expirationDate: values?.expirationDate,
          scheduleType: values?.scheduleType,
          repeatType: values?.repeatType,
          repeatEvery: values?.repeatEvery,
          repeatOn: values?.repeatOn,
          timeSlots: values?.timeSlots,
        });
        let filteredSchedules = scheduleDates?.filter((_s) =>
          moment(_s?.date).isAfter(data?.expirationDate)
        );

        _formData.append(
          "new_end_schedules",
          JSON.stringify(filteredSchedules)
        );
      } else {
        const { scheduleDates } = setScheduleDates({
          medicationDate: moment(data?.expirationDate).add(1, "days"),
          expirationDate: values?.expirationDate,
          scheduleType: values?.scheduleType,
          repeatType: values?.repeatType,
          repeatEvery: values?.repeatEvery,
          repeatOn: values?.repeatOn,
          timeSlots: values?.timeSlots,
        });

        _formData.append("new_end_schedules", JSON.stringify(scheduleDates));
      }

      _formData.append("old_end_date", moment(oldEndDate));
      _formData.append("new_end_date", moment(newEndDate));
    }

    const scheduleChanged =
      values?.scheduleType !== data?.scheduleType ||
      JSON.stringify(values?.timeSlots) !== JSON.stringify(data?.timeSlots) ||
      JSON.stringify(values?.repeatOn) !== JSON.stringify(data?.repeatOn) ||
      values?.repeatType !== data?.repeatType ||
      Number(values?.repeatEvery) !== Number(data?.repeatEvery);

    if (scheduleChanged) {
      const { scheduleDates: newScheduleDates } = setScheduleDates({
        medicationDate: values?.medicationDate,
        expirationDate: values?.expirationDate,
        scheduleType: values?.scheduleType,
        repeatType: values?.repeatType,
        repeatEvery: values?.repeatEvery,
        repeatOn: values?.repeatOn,
        timeSlots: values?.timeSlots,
      });
      _formData.append("updateSchedule", true);
      _formData.append("scheduleDates", JSON.stringify(newScheduleDates));
    }
    setLoading(true);
    await EditMedication(_formData, client?.id, false, reset);
    setLoading(false);
  };

  const formatString = (str) => {
    const words = str?.split("");
    if (words?.length <= 15) {
      return str;
    }
    const startWords = words?.slice(0, 10)?.join("");
    const endWords = words?.slice(-10)?.join("");
    return `${startWords} ... ${endWords}`;
  };

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleDownloadFile = async (url) => {
    try {
      if (url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const filename = url?.split("/")?.pop();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      } else {
        console.error("No url found");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const onChangeMedStartDate = (_sDate) => {
    if (data) {
      // form.values?.repeatType === "week"
      if (form.values?.scheduleType === "custom") {
        if (form.values?.repeatType === "day") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);

          let diff;

          if (newDate < original) {
            diff = original.diff(newDate, "days");
          } else if (newDate > original) {
            diff = newDate.diff(original, "days");
          }

          let repeatDays = Number(form.values?.repeatEvery);

          // Check if the difference is a multiple of repeatDays
          if (diff % repeatDays !== 0) {
            const remainder = Math.abs(diff % repeatDays);
            let validPrevious, validNext;

            if (newDate.isBefore(original)) {
              // Moving backward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = validPrevious.clone().subtract(repeatDays, "days");
            } else {
              // Moving forward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = newDate.clone().add(repeatDays - remainder, "days");
            }

            return alert("Invalid start date");
          } else {
            form.setFieldValue("medicationDate", _sDate);
          }
        } else if (form.values?.repeatType === "week") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);
          const repeatEvery = Number(form.values?.repeatEvery); // e.g., 1 or 2
          const repeatOn = form.values?.repeatOn || [];

          const newDayName = newDate.format("dddd"); // Day name of new start date

          // Step 2: Ensure the new start date is also in repeatOn
          if (!repeatOn.includes(newDayName)) {
            return alert(
              `Invalid start date. Please select a date that falls on: ${repeatOn.join(
                ", "
              )}.`
            );
          }

          // console.log("firstValidDay and newDate", moment(firstValidDay).format("MM-DD-YYYY"), moment(newDate).format("MM-DD-YYYY"))

          // Step 3: Ensure the new date is a multiple of repeatEvery weeks from first valid occurrence
          let weekDiff;
          if (newDate < original) {
            weekDiff = original.diff(newDate.startOf("week"), "weeks");
          } else {
            weekDiff = newDate.diff(original.startOf("week"), "weeks");
          }

          if (Math.abs(weekDiff) % repeatEvery !== 0) {
            return alert(
              `Invalid start date. Please select a date that repeats every ${repeatEvery} weeks on ${repeatOn.join(
                ", "
              )}.`
            );
          } else {
            form.setFieldValue("medicationDate", _sDate);
          }
        } else if (form.values?.repeatType === "month") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);
          const originalDay = original.date(); // e.g., 10th of the month
          const newDay = newDate.date();
          const repeatMonths = Number(form.values?.repeatEvery); // e.g., 1 or 2

          if (repeatMonths === 1) {
            // User can only select the same day of the month (e.g., 10th)
            if (newDay !== originalDay) {
              return alert(
                `Invalid start date. Please select the ${originalDay}th of the month.`
              );
            }
          } else if (repeatMonths > 1) {
            // Ensure the new date is every `repeatMonths` interval
            const monthDiff = newDate.diff(original, "months");
            if (monthDiff % repeatMonths !== 0 || newDay !== originalDay) {
              return alert(
                `Invalid start date. Please select the ${originalDay}th every ${repeatMonths} months.`
              );
            }
          }

          form.setFieldValue("medicationDate", _sDate);
        }
      } else {
        form.setFieldValue("medicationDate", _sDate);
      }
    } else {
      form.setFieldValue("medicationDate", _sDate);
    }
  };

  const onChangeMedEndDate = (_sDate) => {
    if (data) {
      if (form.values?.scheduleType === "custom") {
        if (form.values?.repeatType === "day") {
          const original = moment(data?.expirationDate);
          const newDate = moment(_sDate);

          let diff;

          if (newDate < original) {
            diff = original.diff(newDate, "days");
          } else if (newDate > original) {
            diff = newDate.diff(original, "days");
          }

          let repeatDays = Number(form.values?.repeatEvery);

          // Check if the difference is a multiple of repeatDays
          if (diff % repeatDays !== 0) {
            const remainder = Math.abs(diff % repeatDays);
            let validPrevious, validNext;

            if (newDate.isBefore(original)) {
              // Moving backward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = validPrevious.clone().subtract(repeatDays, "days");
            } else {
              // Moving forward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = newDate.clone().add(repeatDays - remainder, "days");
            }

            return alert("Invalid end date");
          } else {
            form.setFieldValue("expirationDate", _sDate);
          }
          // } else if(form.values?.repeatType === "month"){
        } else {
          form.setFieldValue("expirationDate", _sDate);
        }
      } else {
        form.setFieldValue("expirationDate", _sDate);
      }
    } else {
      form.setFieldValue("expirationDate", _sDate);
    }
  };

  return (
    <Modal
      className={classes.addMedicationModal}
      opened={opened}
      size={1000}
      onClose={() => {
        onclose();
        form?.reset();
      }}
      shadow="md"
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      centered
    >
      <CloseCircle onclose={onclose} />

      <form
        className={classes.modalBody}
        onSubmit={form?.onSubmit((values) => onSave(values))}
      >
        <div className={classes.header}>
          <img src={"/assets/images/pills-icon.png"} alt="pills-icon" />
          <h3>
            {data
              ? isPreview
                ? "Preview Medication"
                : "Change Medication"
              : "Add New Medication"}
          </h3>
        </div>
        <div className={classes.formBox}>
          <div className={classes.wrapper}>
            <div className={classes.headerImage}>
              <img
                src={"/assets/images/medication-modal-icon.png"}
                alt="medication-img"
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-end",
                }}
              >
                {client?.imageurl ? (
                  <img
                    width={"150px"}
                    height={"150px"}
                    style={{ objectFit: "contain", borderRadius: "30px" }}
                    src={
                      selectedClient
                        ? decrypt(selectedClient?.imageurl) || defaultImage
                        : decrypt(client?.imageurl)
                    }
                    alt="client-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultImage;
                    }}
                  />
                ) : (
                  <></>
                )}

                {/* <img
                  width={"150px"}
                  style={{ objectFit: "contain", borderRadius: "30px" }}
                  height={"150px"}
                  src={
                    selectedClient
                      ? decrypt(selectedClient?.imageurl) || defaultImage
                      : decrypt(client?.imageurl)
                  }
                  alt="client-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                /> */}
                <h4 style={{ marginBottom: 0 }}>
                  {selectedClient
                    ? decrypt(selectedClient?.name)
                    : client?.name}
                </h4>
                <span style={{ color: "#979797" }}>
                  {selectedClient
                    ? selectedClient?.id?.slice(0, 6)?.toUpperCase()
                    : client?.id?.slice(0, 6)?.toUpperCase()}
                </span>
              </div>
            </div>
            <div className={classes.topFieldsBox}>
              {/* Is this a prescription medication? */}
              <div className="isPrescribed">
                <Radio.Group
                  name="isPrescribed"
                  label="Is this a prescription medication?"
                  {...form.getInputProps("isPrescribed")}
                  required
                  withAsterisk
                >
                  <Group mt="xs">
                    <Radio disabled={isPreview} value="Yes" label="Yes" />
                    <Radio disabled={isPreview} value="No" label="No" />
                  </Group>
                </Radio.Group>
              </div>
              <div className="isNarcotic">
                <Radio.Group
                  name="isNarcotic"
                  label="Is this a narcotic?"
                  {...form.getInputProps("isNarcotic")}
                  required
                  withAsterisk
                  disabled={isPreview}
                >
                  <Group mt="xs">
                    <Radio disabled={isPreview} value="Yes" label="Yes" />
                    <Radio disabled={isPreview} value="No" label="No" />
                  </Group>
                </Radio.Group>
                <NarcoticBox />
              </div>
            </div>

            <div className={classes.formRow}>
              {/* medication name */}
              <CustomTextInput
                id="medication-name"
                label={"Medication Name"}
                size="sm"
                placeholder={"Enter Medication Name"}
                {...form.getInputProps("medicationName")}
                withAsterisk
                disabled={isPreview}
              />
              {/* medication type */}
              <CustomSelectBox
                id="medication-type"
                label={"Medication Type"}
                size="sm"
                {...form.getInputProps("medicationType")}
                onChange={(value) => {
                  form.setFieldValue("medicationType", value);
                  setType(value);
                }}
                placeholder={"Select Medication Type"}
                withAsterisk
                data={[
                  { value: "PRN", label: "PRN" },
                  { value: "scheduled", label: "SCHEDULED" },
                ]}
                disabled={isPreview}
              />
            </div>

            <div className={classes.medicationDosageBox}>
              <p className="dosageHeading">
                Dosage Information <span style={{ color: "red" }}>*</span>
              </p>
              <div className={classes.medicationDosageInner}>
                {/* medication amount */}
                <TextInput
                  id="medication-amount"
                  // type="number"
                  size="sm"
                  label="Amount"
                  className={classes.forLabel}
                  placeholder="Enter Amount"
                  {...form.getInputProps("dosage")}
                  disabled={isPreview}
                  onWheel={(e) => e.target.blur()}
                />
                {/* medication unit */}
                <Select
                  id="medication-unit"
                  label="Unit"
                  data={[
                    { value: "mg", label: "mg" },
                    { value: "mg/ml", label: "mg/ml" },
                    { value: "cc", label: "cc" },
                    { value: "iu", label: "iu" },
                    { value: "ml", label: "ml" },
                    { value: "puffs", label: "puffs" },
                    { value: "mcg", label: "mcg" },
                    { value: "g", label: "g" },
                    { value: "oz", label: "oz" },
                    { value: "gtts", label: "gtts" },
                    { value: "spray", label: "spray" },
                    { value: "drops", label: "drops" },
                    { value: "unit", label: "unit" },
                  ]}
                  size="sm"
                  className={classes.forLabel}
                  placeholder="Select Unit"
                  {...form.getInputProps("unit")}
                  rightSection={<IconChevronDown color={"#FBAA0D"} size={25} />}
                  rightSectionWidth={30}
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  disabled={isPreview}
                />

                <Select
                  label="Frequency"
                  id="frequency"
                  className={classes.forLabel}
                  data={[...new Set(frequencyData)]}
                  placeholder="Select Frequency"
                  size="sm"
                  {...form.getInputProps("frequency")}
                  rightSection={<IconChevronDown color={"#FBAA0D"} size={25} />}
                  rightSectionWidth={30}
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  disabled={isPreview}
                />
              </div>
            </div>
            {/* medication route */}
            <div className={classes.formRow}>
              <CustomSelectBox
                id="medication-route"
                label={"Medication Route"}
                size="sm"
                placeholder={"Select medication route"}
                data={[
                  { value: "Buccal", label: "Buccal" },
                  { value: "Orally", label: "Orally" },
                  { value: "Intramuscular", label: "Intramuscular" },
                  { value: "Subcutaneous", label: "Subcutaneous" },
                  { value: "Cutaneous", label: "Cutaneous" },
                  { value: "Irrigation", label: "Irrigation" },
                  { value: "Laryngeal", label: "Laryngeal" },
                  { value: "Nasal", label: "Nasal" },
                  { value: "Not Applicable", label: "Not Applicable" },
                  { value: "Parenteral", label: "Parenteral" },
                  { value: "Rectal", label: "Rectal" },
                  { value: "Vaginal", label: "Vaginal" },
                  { value: "Sublingual", label: "Sublingual" },
                  { value: "Suppository", label: "Suppository" },
                  { value: "Injection", label: "Injection" },
                  { value: "Inhalation", label: "Inhalation" },
                  { value: "Topical", label: "Topical" },
                  { value: "Other", label: "Other" },
                ]}
                {...form.getInputProps("ingestionMode")}
                withAsterisk
                disabled={isPreview}
              />
              <CustomSelectBox
                id="dose-form"
                label={"Dose Form"}
                size="sm"
                placeholder={"Select dose form"}
                data={[
                  "Tablet",
                  "Capsule",
                  "Syrup",
                  "Pill",
                  "Liquid",
                  "Cream",
                  "Oil",
                  "Ointment",
                  "Lotion",
                  "Gel",
                  "Gas",
                  "Solution",
                  "Inhalant",
                  "Injection",
                  "Insert",
                  "Suppository",
                  "Jelly",
                  "Lozenge",
                  "Paste",
                  "Patch",
                  "Rinse",
                  "Shampoo",
                  "Drops",
                  "Spray",
                  "Powder",
                ]}
                {...form.getInputProps("dosageForm")}
                disabled={isPreview}
              />
            </div>

            <Box mb={10} className={classes.medicationCountBox}>
              <Radio.Group
                label="Use Medication Count?"
                onChange={handleRadioChange}
                value={isMedicationCountEnabled}
                disabled={isPreview}
              >
                <Group mt="xs">
                  <Radio disabled={isPreview} value="yes" label="Yes" />
                  <Radio disabled={isPreview} value="no" label="No" />
                </Group>
              </Radio.Group>
            </Box>

            {/* medicineProvided */}
            <div className={classes.formRow}>
              {/* medication quantity */}
              <CustomTextInput
                id="medication-quantity"
                size="sm"
                type="number"
                placeholder={"Enter Medication Total Quantity"}
                {...form.getInputProps("totalMedicine")}
                withAsterisk={
                  isMedicationCountEnabled?.toLowerCase() === "no"
                    ? false
                    : true
                }
                disabled={
                  isPreview || isMedicationCountEnabled?.toLowerCase() === "no"
                    ? true
                    : false
                }
                label={
                  <span
                    className={cx(
                      isPreview ||
                        isMedicationCountEnabled?.toLowerCase() === "no"
                        ? classes.disabledLabel
                        : classes.normalLabel
                    )}
                  >
                    Medication Total Quantity
                  </span>
                }
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.includes(".")) {
                    const [integerPart, decimalPart] = value.split(".");
                    if (decimalPart?.length > 1) {
                      value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                    }
                  }
                  form.setFieldValue("totalMedicine", value);
                }}
                step="0.1"
                // onBlur={(e) => {
                //   const value = parseFloat(e.target.value);
                //   if (!isNaN(value)) {
                //     const formatted = value.toFixed(1);
                //     e.target.value = formatted;
                //     form.setFieldValue("totalMedicine", formatted);
                //   }
                // }}
                onWheel={(e) => e.target.blur()}
              />
              {/* medication count */}
              <CustomTextInput
                id="current-medication-count"
                size="sm"
                type="number"
                placeholder={"Enter Current Count"}
                {...form.getInputProps("medicineRemaining")}
                disabled={
                  // data?.medicineRemaining === "unlimited" ||
                  isPreview ||
                  isMedicationCountEnabled?.toLowerCase() === "no" ||
                  (isMedicationCountEnabled?.toLowerCase() === "yes" &&
                  data?.medicineRemaining === undefined
                    ? data?.medicineRemaining == "unlimited"
                    : data?.medicineRemaining !== "unlimited")
                    ? true
                    : false
                }
                label={
                  <Tooltip
                    label="Update Current Count from Refill Medication"
                    placement="top"
                    offset={15}
                    withArrow
                    arrowSize={8}
                    disabled={
                      isPreview ||
                      !data ||
                      (data?.medicineRemaining === "unlimited" &&
                        data?.totalMedicine === "unlimited")
                    }
                  >
                    <span
                      className={cx(
                        // data ||
                        isPreview ||
                          isMedicationCountEnabled?.toLowerCase() === "no"
                          ? classes.disabledLabel
                          : classes.normalLabel
                      )}
                    >
                      Current Medication Count
                    </span>
                  </Tooltip>
                }
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.includes(".")) {
                    const [integerPart, decimalPart] = value.split(".");
                    if (decimalPart?.length > 1) {
                      value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                    }
                  }
                  form.setFieldValue("medicineRemaining", value);
                }}
                step="0.1"
                // onBlur={(e) => {
                //   const value = parseFloat(e.target.value);
                //   if (!isNaN(value)) {
                //     const formatted = value.toFixed(2);
                //     e.target.value = formatted;
                //     form.setFieldValue("medicineRemaining", formatted);
                //   }
                // }}
                onWheel={(e) => e.target.blur()}
              />
              {/* administration count */}
              <CustomTextInput
                id="administration-count"
                type="number"
                label={"Dosage Administered"}
                size="sm"
                placeholder={"Enter Dosage Administered"}
                {...form.getInputProps("medicationadministered")}
                disabled={isPreview}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.includes(".")) {
                    const [integerPart, decimalPart] = value.split(".");
                    if (decimalPart?.length > 1) {
                      value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                    }
                  }
                  form.setFieldValue("medicationadministered", value);
                }}
                step="0.1"
                // onBlur={(e) => {
                //   const value = parseFloat(e.target.value);
                //   if (!isNaN(value)) {
                //     const formatted = value.toFixed(2);
                //     e.target.value = formatted;
                //     form.setFieldValue("medicationadministered", formatted);
                //   }
                // }}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            {/* use of medication */}
            <div className={classes.formRow}>
              <CustomTextArea
                id="use-of-medication"
                size="sm"
                label={"Use of Medication"}
                placeholder={"Enter medication use"}
                minRows={3}
                {...form.getInputProps("medicationUse")}
                disabled={isPreview}
              />
            </div>
            {/* medication instruction */}
            <div className={classes.formRow}>
              <CustomTextArea
                id="medication-instruction"
                size="sm"
                label={"Medication Instruction"}
                placeholder={"Enter medication Instruction"}
                minRows={3}
                {...form.getInputProps("medicationInstruction")}
                disabled={isPreview}
              />
            </div>

            <div className={classes.formRow}>
              {/* responsible for purchasing */}
              <CustomSelectBox
                id="responsible-for-purchasing"
                label={"Responsible for purchasing"}
                size="sm"
                placeholder={"Select purchasing party"}
                data={[
                  { value: "Family", label: "Family" },
                  { value: "Care Facility", label: "Care Facility" },
                  { value: "Doctor/Nurse", label: "Doctor/Nurse" },
                  { value: "Other", label: "Other" },
                ]}
                {...form.getInputProps("responsibleParty")}
                disabled={isPreview}
              />
              <CustomSelectBox
                id="responsible-for-administering"
                label={"Responsible for administering"}
                size="sm"
                placeholder={"Select administering party"}
                data={[
                  { value: "Family", label: "Family" },
                  { value: "Care Facility", label: "Care Facility" },
                  { value: "Doctor/Nurse", label: "Doctor/Nurse" },
                  { value: "Other", label: "Other" },
                ]}
                {...form.getInputProps("administering")}
                disabled={isPreview}
              />
            </div>

            <div className={classes.bottomFields}>
              <div className={classes.bottomFieldsInner}>
                <DateInput
                  id="medication-start-date"
                  size="sm"
                  placeholder={"mm/dd/yyyy"}
                  label="Medication Start Date"
                  rightSection={
                    <img
                      style={{ width: "30px" }}
                      src={"/assets/images/calendar-icon.png"}
                      alt="Icon"
                    />
                  }
                  {...form.getInputProps("medicationDate")}
                  onChange={onChangeMedStartDate}
                  withAsterisk
                  style={{ cursor: "pointer" }}
                  // disabled={isPreview || data}
                  disabled={isPreview}
                  styles={{ rightSection: { pointerEvents: "none" } }}
                />
                <DateInput
                  id="expriration-date"
                  minDate={new Date()}
                  size="sm"
                  placeholder={"mm/dd/yyyy"}
                  label="Expiration Date"
                  rightSection={
                    !form.getInputProps("expirationDate")?.value ? (
                      <img
                        style={{ width: "30px" }}
                        src={"/assets/images/calendar-icon.png"}
                        alt="Icon"
                      />
                    ) : (
                      false
                    )
                  }
                  disabled={isPreview}
                  {...form.getInputProps("expirationDate")}
                  onChange={onChangeMedEndDate}
                  styles={
                    !form.getInputProps("expirationDate")?.value
                      ? { rightSection: { pointerEvents: "none" } }
                      : {}
                  }
                  clearable
                />
                {type !== "PRN" && (
                  <div className={classes.adminScheduleBox}>
                    <div className="heading">
                      <p className="label">
                        Administration Schedule
                        <span style={{ color: "red" }}>*</span>
                      </p>
                      {/* {(isPreview || data) && ( */}
                      <ScheduleMenu
                        form={form}
                        isPreview={isPreview}
                        data={data}
                      />
                      {/* )} */}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      {form.values?.scheduleType === "custom" ? (
                        <p
                          className={classes.scheduleMenuBtnText}
                          style={{ cursor: "default" }}
                        >
                          Repeats every{" "}
                          <span
                            style={{
                              background: "#D9D9D9",
                              color: "black",
                              paddingInline: "5px",
                            }}
                          >
                            {form.values?.repeatEvery}
                          </span>{" "}
                          <span style={{ textTransform: "capitalize" }}>
                            {form.values?.repeatType}
                          </span>
                          (s)
                        </p>
                      ) : (
                        <p
                          className={classes.scheduleMenuBtnText}
                          style={{ cursor: "default" }}
                        >
                          Daily
                        </p>
                      )}
                      {form.values?.scheduleType === "custom" &&
                        form.values?.repeatType === "month" && (
                          <p
                            className={classes.monthRepeatBox}
                            style={{ cursor: "default" }}
                          >
                            On the{" "}
                            {moment(form.values?.medicationDate).get("date")}
                          </p>
                        )}

                      {form.values?.scheduleType === "custom" &&
                        form.values?.repeatType === "week" && (
                          <div
                            className={classes.repeatOn}
                            style={{
                              background: "white",
                              borderRadius: "15px",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "5px",
                            }}
                          >
                            <div
                              className="dayCircleBox"
                              style={{ alignItems: "center", marginTop: "0" }}
                            >
                              {daysOfWeek.map((day) => (
                                <div
                                  key={day}
                                  className={`dayCircle ${
                                    form.values?.repeatOn?.includes(day)
                                      ? "dayCircleActive"
                                      : "dayCircleInactive"
                                  }`}
                                  // onClick={() => (!isPreview ? toggleDay(day) : () => {})}
                                >
                                  <p>{day.charAt(0).toUpperCase()}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                    </div>
                    {/* {!isPreview && !data ? (
                      <ScheduleMenu
                        form={form}
                        isPreview={isPreview}
                        data={data}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        {data?.scheduleType === "custom" ? (
                          <p
                            className={classes.scheduleMenuBtnText}
                            style={{ cursor: "default" }}
                          >
                            Repeats every{" "}
                            <span
                              style={{
                                background: "#D9D9D9",
                                color: "black",
                                paddingInline: "5px",
                              }}
                            >
                              {data?.repeatEvery}
                            </span>{" "}
                            <span style={{ textTransform: "capitalize" }}>
                              {data?.repeatType}
                            </span>
                            (s)
                          </p>
                        ) : (
                          <p
                            className={classes.scheduleMenuBtnText}
                            style={{ cursor: "default" }}
                          >
                            Daily
                          </p>
                        )}
                        {data?.scheduleType === "custom" &&
                          data?.repeatType === "month" && (
                            <p
                              className={classes.monthRepeatBox}
                              style={{ cursor: "default" }}
                            >
                              On the {moment(data?.medicationDate).get("date")}
                            </p>
                          )}

                        {data?.scheduleType === "custom" &&
                          data?.repeatType === "week" && (
                            <div
                              className={classes.repeatOn}
                              style={{
                                background: "white",
                                borderRadius: "15px",
                                height: "40px",
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "5px",
                              }}
                            >
                              <div
                                className="dayCircleBox"
                                style={{ alignItems: "center", marginTop: "0" }}
                              >
                                {daysOfWeek.map((day) => (
                                  <div
                                    key={day}
                                    className={`dayCircle ${
                                      data?.repeatOn?.includes(day)
                                        ? "dayCircleActive"
                                        : "dayCircleInactive"
                                    }`}
                                    // onClick={() => (!isPreview ? toggleDay(day) : () => {})}
                                  >
                                    <p>{day.charAt(0).toUpperCase()}</p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                      </div>
                    )} */}
                  </div>
                )}
              </div>
            </div>

            <div className={classes.uploadAndDateBox}>
              <div className={classes.dropzone}>
                <Dropzone
                  // onDrop={(newFiles) => setFiles([...files, ...newFiles])}
                  onDrop={async (newFiles) => {
                    if (!newFiles?.[0]) return;
                    const file = newFiles[0];
                    try {
                      // Upload to S3
                      const result = await uploadFileToS3Api({ file });
                      setFiles([result]);
                    } catch (error) {
                      showError?.(error?.message || "Upload failed");
                    }
                  }}
                  multiple={false}
                  onReject={(files) => console.log("rejected files", files)}
                  disabled={isPreview}
                >
                  <Group
                    position="center"
                    spacing="xl"
                    style={{ minHeight: rem(220), pointerEvents: "none" }}
                  >
                    <Dropzone.Accept></Dropzone.Accept>
                    <Dropzone.Reject></Dropzone.Reject>
                    <Dropzone.Idle></Dropzone.Idle>

                    <div className={classes.column}>
                      <img
                        src="/assets/images/drag.png"
                        alt="Drag & Drop"
                        className={classes.dragImage}
                      />
                      <p className={classes.uploadText}>
                        <span>Upload</span> Doctor's Note
                      </p>
                    </div>
                  </Group>
                </Dropzone>
                {files?.length > 0 && (
                  <div className={classes.fileNameBox}>
                    <p>{formatString(files[0]?.path)}</p>
                    <IoIosCloseCircle
                      color="rgba(255, 72, 72, 0.18)"
                      size={25}
                      style={{ cursor: "pointer" }}
                      onClick={() => setFiles([])}
                    />
                  </div>
                )}
              </div>
              <div className={classes.datePicker}>
                <DatePickerInput
                  id="order-date"
                  label="Order Date"
                  size="xl"
                  placeholder="mm/dd/yyyy"
                  rightSection={
                    <img
                      style={{ width: "30px" }}
                      src={"/assets/images/calendar-icon.png"}
                      alt="Icon"
                    />
                  }
                  // withAsterisk
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  {...form.getInputProps("orderDate")}
                  disabled={isPreview}
                />
              </div>
            </div>
            <div style={{ marginTop: "20px" }}>
              <span style={{ color: "transparent" }}>.</span>
            </div>
            {data?.doctorNote && isPreview && (
              <>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <b>Download</b>
                  <img
                    src="/assets/images/downloadFolder.png"
                    alt="download"
                    width={30}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDownloadFile(data?.doctorNote)}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <span style={{ color: "transparent" }}>.</span>
                </div>
              </>
            )}
          </div>
        </div>
        {!isPreview && (
          <div className={classes.saveButton}>
            <Button
              id="save-medication"
              loading={loading}
              type="submit"
              style={{ width: loading ? "150px" : "110px" }}
            >
              <img src="/assets/images/save-icon.png" alt="" />
              Save
            </Button>
          </div>
        )}
      </form>
      <ConfirmationModal
        opened={confirmModal}
        close={confirmClose}
        handleEdit={() => {
          handleEdit(true);
        }}
      />
    </Modal>
  );
};

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "5px",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput min={0} {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "5px",
      backgroundColor: bgColor,
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#FBAA0D"} size={25} />}
        rightSectionWidth={30}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

const CustomTextArea = ({ label, withAsterisk, ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      border: "1px solid rgba(0,0,0,0.1)",
      padding: "5px 15px",
      borderRadius: "15px",
      position: "relative",
      "& .mantine-Textarea-input": {
        border: "none",
        paddingInline: "0",
      },
      "& .label": {
        position: "absolute",
        top: -10,
        left: 30,
        zIndex: 100,
        color: "#000",
        margin: 0,
        backgroundColor: "#fff",
        display: "inline-block",
        fontSize: "14px",
        fontWeight: 500,
        paddingInline: "10px",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <p className="label">
        {label} {withAsterisk && <span style={{ color: "red" }}>*</span>}
      </p>
      <Textarea {...rest} />
    </div>
  );
};

export default AddNewMedicationModal;
